import {Exclude, Expose, Type} from 'class-transformer';
import { AgreementGroupApiModel } from './agreement-group.api.model';
import { AgreementApiModel } from './agreement.api.model';

@Exclude()
export class AgreementAggregationApiModel {
  @Expose()
  @Type(() => AgreementApiModel)
  marketingAgreements: AgreementApiModel[];

  @Expose()
  @Type(() => AgreementGroupApiModel)
  marketingAgreementGroups: AgreementGroupApiModel[];
}
